import { api as generatedApi } from 'gen/rtk-openapi'
import { ASSET_CATEGORY } from 'utils/constants'

const TAG_TYPES = {
  container: ASSET_CATEGORY.CONTAINER,
  truck: ASSET_CATEGORY.TRUCK,
  trailer: ASSET_CATEGORY.TRAILER,
  // only use for physical assets by id requests
  physicalAsset: 'PHYSICAL_ASSET',
  containerAssetType: 'CONTAINER_ASSET_TYPE',
  truckAssetType: 'TRUCK_ASSET_TYPE',
  trailerAssetType: 'TRAILER_ASSET_TYPE',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [
    TAG_TYPES.container,
    TAG_TYPES.truck,
    TAG_TYPES.trailer,
    TAG_TYPES.physicalAsset,
    TAG_TYPES.containerAssetType,
    TAG_TYPES.truckAssetType,
    TAG_TYPES.trailerAssetType,
  ],
  endpoints: {
    getAssetsByCategory: {
      providesTags: (result, _error, { assetCategory }) =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(physicalAsset => ({
                type: TAG_TYPES.physicalAsset,
                id: physicalAsset.id,
              })),
              { type: TAG_TYPES[assetCategory.toLowerCase()], id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'PhysicalAssets', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES[assetCategory.toLowerCase()], id: 'LIST' }],
    },
    getAssetTypes: {
      providesTags: (_result, _error, { assetCategory }) => [
        { type: TAG_TYPES[`${assetCategory.toLowerCase()}AssetType`], id: 'LIST' },
      ],
    },
    createAssetTypes: {
      invalidatesTags: (_result, _error, { assetCategory }) => [
        { type: TAG_TYPES[`${assetCategory.toLowerCase()}AssetType`], id: 'LIST' },
      ],
    },
    updateAssetTypes: {
      invalidatesTags: (_result, _error, { assetCategory }) => [
        { type: TAG_TYPES[assetCategory.toLowerCase()], id: 'LIST' },
        { type: TAG_TYPES[`${assetCategory.toLowerCase()}AssetType`], id: 'LIST' },
      ],
    },
    getAssetByCategoryAndId: {
      providesTags: (_result, _error, { assetCategory, assetId }) => [
        { type: TAG_TYPES.physicalAsset, id: assetId },
        { type: TAG_TYPES[`${assetCategory.toLowerCase()}AssetType`], id: 'LIST' },
      ],
    },
    createPhysicalAsset: {}, // Tag invalidation after asset creation is handled in "createAssetStatus" endpoint
    patchPhysicalAsset: {
      invalidatesTags: (_result, _error, { assetCategory, assetId }) => [
        { type: TAG_TYPES[assetCategory.toLowerCase()], id: 'LIST' },
        { type: TAG_TYPES.physicalAsset, id: assetId },
      ],
    },
    createAssetStatus: {
      invalidatesTags: (_result, _error, { assetCategory, assetId }) => [
        { type: TAG_TYPES[assetCategory.toLowerCase()], id: 'LIST' },
        { type: TAG_TYPES.physicalAsset, id: assetId },
      ],
    },
    getAssetHistory: {
      providesTags: (_result, _error, { assetId }) => [{ type: TAG_TYPES.physicalAsset, id: assetId }],
    },
    // archivePhysicalAsset: {
    //   invalidatesTags: (result, error, { assetId }) => [
    //     { type: TAG_TYPES.physicalAsset, id: assetId },
    //   ],
    // },
  },
})

export const {
  useGetAssetsByCategoryQuery,
  useGetAssetTypesQuery,
  useCreateAssetTypesMutation,
  useUpdateAssetTypesMutation,
  useGetAssetByCategoryAndIdQuery,
  useCreatePhysicalAssetMutation,
  usePatchPhysicalAssetMutation,
  useCreateAssetStatusMutation,
  useGetAssetHistoryQuery,
  // useArchivePhysicalAssetMutation,
} = api
